(function () {
	'use strict';

	angular.module('l4b')
		.component('enrollmentNotFound', {
			templateUrl: 'html/modules/_components/enrollmentNotFound/enrollmentNotFound.html',
			bindings: {
			},
			controller: EnrollmentNotFound,
			controllerAs: 'vm'
		});

	function EnrollmentNotFound(StorageService, $location, Constants, ModalService) {
		var 
			vm = this;

		angular.extend(vm, {
			$onInit: init,
			goBack: goBack
			
		});
		
		function init() {
		}

		function goBack() {
			ModalService.Close('enrollment-not-found');
			$location.url(StorageService.get(Constants.SK.StartFlowUrl));
		}

		
		
		
	}
})();